const WISHLIST_KEY = 'ac_wishlist';

function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
}

function saveWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
}

function isWishlisted(handle) {
  return getWishlist().includes(handle);
}

function toggleWishlist(handle, title, image, url, price) {
  let list = getWishlist();
  let items = JSON.parse(localStorage.getItem(WISHLIST_KEY + '_meta') || '{}');

  if (list.includes(handle)) {
    list = list.filter(h => h !== handle);
    delete items[handle];
  } else {
    list.push(handle);
    items[handle] = { title, image, url, price };
  }

  saveWishlist(list);
  localStorage.setItem(WISHLIST_KEY + '_meta', JSON.stringify(items));
  document.querySelectorAll(`.wishlist-btn[data-handle="${handle}"]`).forEach(btn => {
    updateWishlistBtn(btn, list.includes(handle));
  });
}

function updateWishlistBtn(btn, wishlisted) {
  btn.classList.toggle('wishlisted', wishlisted);
  btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Save to wishlist');
}

function initWishlistButtons() {
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const handle = btn.dataset.handle;
    updateWishlistBtn(btn, isWishlisted(handle));
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const { handle, title, image, url, price } = btn.dataset;
      toggleWishlist(handle, title, image, url, price);
    });
  });
}

document.addEventListener('DOMContentLoaded', initWishlistButtons);
